import { Timestamp } from '../types';

export function isExpired(value: Timestamp | Date | null | undefined): boolean {
	if (!value) return false;

	const now = new Date();
	let date: Date;

	// Handle Firestore Timestamp
	if (!(value instanceof Date) && typeof value.toDate === 'function') {
		date = value.toDate();
	} else if (value instanceof Date) {
		date = value;
	} else {
		return false;
	}

	// Check if the timestamp is in the past
	return date.getTime() < now.getTime();
}

export function getCutoffDate(aliveDays: number): Date {
	const now = new Date();
	now.setHours(0, 0, 0, 0);

	const cutoffMs = now.getTime() - aliveDays * 24 * 60 * 60 * 1000;
	return new Date(cutoffMs);
}

export type MonthRange = {
	startDate: Date;
	endDate: Date;
	monthLabel: string;
};

export function getPreviousMonthRange(): MonthRange {
	const now = new Date();
	const endDate = new Date(now.getFullYear(), now.getMonth(), 1);
	const startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
	const monthLabel = startDate.toLocaleString('default', {
		month: 'long',
		year: 'numeric',
	});

	return { startDate, endDate, monthLabel };
}
